export const replaceThamDomainWithProxyCdn = (
  content: string,
  token: string,
  proxyDomain: string,
) => {
  return content?.replace(
    /https:\/\/secure\.tham\.thiememeulenhoff\.nl([^?"'\s<>)]*)(?:\?[^"'<>)]*)?/g,
    (_match, path) => `${proxyDomain}${path}?authorization=${token}`,
  );
};
